import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { initPortalEmbedBridge } from "../utils/portalEmbedApi";

const TRUSTED_PORTAL_ORIGINS = new Set([
  "http://localhost:3000",
  "https://cenze-links.vercel.app",
  "https://portalcenze.vercel.app",
]);

const PortalSsoPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    initPortalEmbedBridge();

    const handlePortalMessage = (event) => {
      if (!TRUSTED_PORTAL_ORIGINS.has(event.origin)) {
        return;
      }
      const data = event.data || {};
      if (data.type === "PORTAL_SSO_SESSION" && data.token) {
        localStorage.setItem("portalToken", data.token);
        if (data.refreshToken) {
          localStorage.setItem("portalRefreshToken", data.refreshToken);
        }
        navigate("/", { replace: true });
      }
    };

    window.addEventListener("message", handlePortalMessage);

    const portalToken = searchParams.get("portalToken");
    if (portalToken) {
      localStorage.setItem("portalToken", portalToken);
      const refreshToken = searchParams.get("portalRefreshToken");
      if (refreshToken) {
        localStorage.setItem("portalRefreshToken", refreshToken);
      }
      navigate("/", { replace: true });
    }

    return () => {
      window.removeEventListener("message", handlePortalMessage);
    };
  }, [navigate, searchParams]);

  return <div style={{ padding: 16 }}>Conectando com o portal...</div>;
};

export default PortalSsoPage;
